const appPaths = {
  root: "/",
  login: "/login",
  usersManagement: "/management/users",
  snippetsManagement: "/management/snippets",
  product: "/product/:productId",
  productCreate: "/product/create",
  productEdit: "/product/:productId/edit",
} as const;

type AppPath = typeof appPaths;

export const paths = {
  root: {
    getHref() {
      return appPaths.root;
    },
  },
  login: {
    getHref() {
      return appPaths.login;
    },
  },
  usersManagement: {
    getHref() {
      return appPaths.usersManagement;
    },
  },
  snippetsManagement: {
    getHref() {
      return appPaths.snippetsManagement;
    },
  },
  product: {
    getHref(productId: string) {
      return `/product/${productId}` as AppPath["product"];
    },
  },
  productCreate: {
    getHref() {
      return appPaths.productCreate;
    },
  },
  productEdit: {
    getHref(productId: string) {
      return `/product/${productId}/edit` as AppPath["productEdit"];
    },
  },
} as const;
